import React, { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import SoftwareDev from "../../Assets/Images/service-icons/software-development.svg";
import HireDev from "../../Assets/Images/service-icons/hire-developer.svg";
import WebDev from "../../Assets/Images/service-icons/web-developer.svg";
import SoftConsult from "../../Assets/Images/service-icons/software-consult.svg";
import DataAnalytics from "../../Assets/Images/service-icons/data-analytic.svg";
// import MobileAppDev from "../../Assets/Images/service-icons/mobile-dev.svg";
import Consulting from "../../Assets/Images/pm-services-icon/collab.svg";
import BusinessIntelligence from "../../Assets/Images/pm-services-icon/success-manage.svg";
import OutsourcingServices from "../../Assets/Images/pm-services-icon/adapt.svg";
import "./Offering-service.css";

const OfferingServicePage = () => {
  const listOfServices = [
    {
      img: SoftwareDev,
      title: "Offshore Software Development",
      path: "/services/custom-software-development",
      description:
        "Form committed teams in Bangladesh with a sense of your own. Our quality combines best engineering skills with transparent processes and cost effectiveness to facilitate your growth without sacrificing control and quality.",
    },
    {
      img: WebDev,
      title: "Web Development",
      path: "/services/web-development",
      description:
        "We provide website designs and development services for sites that can achieve more than just being beautiful to look at. In fact, our website solutions can be fast and scalable to support real users, real traffic, and real business growth.",
    },
    {
      img: HireDev,
      title: "Business Analysis",
      path: "/services/developers-for-hire",
      description:
        "We ask the tough questions before any coding can begin. Our business analysts are able to help close the gaps and prove out concepts before settling on extremely clear and actionable development plans.",
    },
    {
      img: SoftConsult,
      title: "Communications Technology",
      path: "/services/software-consulting",
      description:
        "Strong systems are all about strong links. Our communication systems are designed for alignment between teams, systems, and users through use of robust, secure, and future-proof technologies.",
    },
    {
      img: DataAnalytics,
      title: "Data Analytics",
      path: "/services/data-analytics",
      description:
        "Your data also has a story to tell. We help with the easy interpretation of your data. Our analytics solution services unlock your data to make it possible for better decision-making.",
    },
    {
      img: OutsourcingServices,
      title: "Outsourcing Services",
      path: "/services/mobile-app-development",
      description:
        "When speed matters, outsourcing should feel seamless. We integrate skilled professionals into your workflow, so projects move faster without sacrificing quality or accountability.",
    },
    {
      img: BusinessIntelligence,
      title: "Business Intelligence",
      path: "/services/software-consulting",
      description:
        "We synthesize fragmented data into intelligible visibility. Our Business Intelligence tools allow managers to track related trends in business that can be responded to, not just deduced.",
    },
    {
      img: Consulting,
      title: "Consulting",
      path: "/services/software-consulting",
      description:
        "Sometimes, progress starts with perspective. Our consulting offers you the chance to think beyond systems, develop processes, and implement technology that drives sustainable growth.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const rowRef = useRef(null);
  const progressRef = useRef(null);

  useEffect(() => {
    const row = rowRef.current;
    const progress = progressRef.current;
    if (!row || !progress || listOfServices.length === 0) return;

    // Update progress bar
    const percent = ((activeIndex + 1) / listOfServices.length) * 100;
    progress.style.transition = "width 0.4s ease";
    progress.style.width = `${percent}%`;

    if (window.innerWidth < 1024) {
      // Mobile: scroll to active card
      const activeCard = row.children[activeIndex];
      if (activeCard) {
        activeCard.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    } else {
      // Desktop: calculate transform shift to prevent empty space at the end
      const cardWidth = row.children[0]?.offsetWidth + 30 || 0;
      const visibleCards = Math.floor(row.offsetWidth / cardWidth);
      const maxOffset = (listOfServices.length - visibleCards) * cardWidth;
      const rawOffset = (activeIndex - 1) * cardWidth;
      const offset = Math.max(0, Math.min(rawOffset, maxOffset));

      row.style.transition = "transform 0.5s ease";
      row.style.transform = `translateX(-${offset}px)`;
    }
  }, [activeIndex, listOfServices.length]);

  return (
    <div id="services" className="offering-service-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/* Top Content */}
            <div className="top-contents">
              <h1 className="service-headline1">
                Services Built Around Real Problems
              </h1>
              <p className="service-text1">
                All the services we sell have one objective and one objective
                only: to simplify your business and help you move forward. We
                don't just sell features. We help you solve your problems and
                address your needs today and in the future.
              </p>
            </div>

            {/* Carousel */}
            <div className="middle-contents">
              <div className="carousel-wrapper">
                <div className="service-row" ref={rowRef}>
                  {listOfServices.map((service, i) => (
                    <div
                      key={i}
                      className={`service-card ${
                        i === activeIndex ? "active" : ""
                      }`}
                      onClick={() => setActiveIndex(i)}
                    >
                      <div className="service-icons">
                        <img src={service.img} alt={service.title} width={60} />
                      </div>
                      <h2 className="service-project-title">{service.title}</h2>
                      <p className="service-project-description">
                        {service.description}
                      </p>
                      <Link to={service.path} className="see-more-btn">
                        See More
                        <Icon
                          className="see-more-icon"
                          icon="weui:arrow-outlined"
                          width="12"
                        />
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="end-contents">
              <div className="progress-container">
                <div className="progress-bar" ref={progressRef}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferingServicePage;
